import './load-templates'
function importAll (r) {
  r.keys().forEach(r);
}
importAll(require.context('../../assets/javascripts', true, /\.coffee$/));
